import YwButton from "./components/button/index.js";
import YwLayout from "./components/layout/index.js";
import YwDivider from "./components/divider/index.js";
import YwSpace from "./components/space/index.js";
import YwIcon from "./components/icon/index.js";
import YwMenu from "./components/menu/index.js";
import { YwCol, YwRow } from "./components/grid/index.js";
import YwInput from "./components/input/index.js";
import YwSelect from "./components/select/index.js";
import YwTabs from "./components/tabs/index.js";
import YwPagination from "./components/pagination/index.js";
import YwDrawer from "./components/drawer/index.js";
import YwForm from "./components/form/index.js";
import YwTable from "./components/table/index.js";
import YwCard from "./components/card/index.js";
import YwBreadcrumb from "./components/breadRumb/index.js";
import YwModal from "./components/modal/index.js";
import YwSpin from "./components/spin/index.js";
import YwPopover from "./components/popover/index.js";
import YwDropdown from "./components/dropdown/index.js";
import YwPopconfirm from "./components/popConfirm/index.js";
import YwTag from "./components/tag/index.js";
import YwDatePicker from "./components/datePicker/index.js";
import YwTree from "./components/tree/index.js";
import YwProgress from "./components/progress/index.js";
import YwTooltip from "./components/tooltip/index.js";
import YwSteps from "./components/steps/index.js";
import YwCheckbox from "./components/checkbox/index.js";
import YwCascader from "./components/cascader/index.js";
import YwSwitch from "./components/switch/index.js";
import YwConfigProvider from "./components/configProvider/index.js";
import YwLocaleProvider from "./components/localeProvider/index.js";
import YwPageHeader from "./components/pageHeader/index.js";
import YwSlider from "./components/slider/index.js";
import YwAvatar from "./components/avatar/index.js";
import YwCalendar from "./components/calendar/index.js";
import YwSkeleton from "./components/skeleton/index.js";
import YwRadio from "./components/radio/index.js";
import Ywmessage from "./components/message/index.js";
import YwList from "./components/list/index.js";
import YwMentions from "./components/mentions/index.js";
import YwRate from "./components/rate/index.js";
import YwAutoComplete from "./components/autoComplete/index.js";
import YwInputNumber from "./components/inputNumber/index.js";
import YwNotification from "./components/notification/index.js";
import YwFormModel from "./components/formModel/index.js";
import YwBadge from "./components/badge/index.js";
import YwDescriptions from "./components/description/index.js";
import YwTimePicker from "./components/timePicker/index.js";
import YwContainer from "./components/pageContainer/index.js";
import YwCollapse from "./components/collapse/index.js";
import YwTransfer from "./components/transfer/index.js";
import YwTransferModal from "./components/transferModal/index.js";
import YwMultipleCascader from "./components/multipleCascader/index.js";
import YwAffix from "./components/affix/index.js";
import YwAlert from "./components/alert/index.js";
import YwAnchor from "./components/anchor/index.js";
import YwBackTop from "./components/backtop/index.js";
import YwLoading from "./components/loading/index.js";
import YwSearchGroup from "./components/searchGroup/index.js";
import YwEmpty from "./components/empty/index.js";

const components = [
	YwButton,
	YwLayout,
	YwDivider,
	YwSpace,
	YwCol,
	YwRow,
	YwIcon,
	YwInput,
	YwSelect,
	YwTabs,
	YwPagination,
	YwDrawer,
	YwMenu,
	YwForm,
	YwTable,
	YwCard,
	YwBreadcrumb,
	YwSpin,
	YwModal,
	YwPopover,
	YwTag,
	YwDropdown,
	YwPopconfirm,
	YwPageHeader,
	YwRadio,
	Ywmessage,
	YwList,
	YwMentions,
	YwRate,
	YwDatePicker,
	YwTree,
	YwProgress,
	YwTooltip,
	YwSteps,
	YwCheckbox,
	YwCascader,
	YwSwitch,
	YwConfigProvider,
	YwLocaleProvider,
	YwAutoComplete,
	YwInputNumber,
	YwNotification,
	YwSkeleton,
	YwSlider,
	YwAvatar,
	YwCalendar,
	YwFormModel,
	YwDescriptions,
	YwBadge,
	YwTimePicker,
	YwContainer,
	YwCollapse,
	YwTransferModal,
	YwTransfer,
	YwMultipleCascader,
	YwAffix,
	YwAlert,
	YwAnchor,
	YwBackTop,
	YwLoading,
	YwSearchGroup,
	YwEmpty
];
// 定义install方法，接收Vue作为参数
const install = function (Vue) {
	if (install.installed) return;
	//全局注册组件
	components.map(component => {
		if (component.install) {
			component.install(Vue);
		}
		// Vue.component(component.name, component);
	});
};

//判断是否直接引入文件，如果是，就不用调用Vue.use()
if (typeof window !== "undefined" && window.Vue) {
	install(window.Vue);
}

// 导出的对象必须具有 install，才能被 Vue.use() 方法安装
export {
	install,
	YwButton,
	YwLayout,
	YwDivider,
	YwSpace,
	YwCol,
	YwRow,
	YwIcon,
	YwInput,
	YwSelect,
	YwTabs,
	YwPagination,
	YwDrawer,
	YwMenu,
	YwForm,
	YwTable,
	YwCard,
	YwBreadcrumb,
	YwSpin,
	YwModal,
	YwPopover,
	YwTag,
	YwDropdown,
	YwPopconfirm,
	YwPageHeader,
	YwRadio,
	Ywmessage,
	YwList,
	YwMentions,
	YwRate,
	YwDatePicker,
	YwTree,
	YwProgress,
	YwTooltip,
	YwSteps,
	YwCheckbox,
	YwCascader,
	YwSwitch,
	YwConfigProvider,
	YwLocaleProvider,
	YwAutoComplete,
	YwInputNumber,
	YwNotification,
	YwSkeleton,
	YwSlider,
	YwAvatar,
	YwCalendar,
	YwFormModel,
	YwDescriptions,
	YwBadge,
	YwTimePicker,
	YwContainer,
	YwCollapse,
	YwTransferModal,
	YwTransfer,
	YwMultipleCascader,
	YwAffix,
	YwAlert,
	YwAnchor,
	YwBackTop,
	YwLoading,
	YwSearchGroup,
	YwEmpty
};
export default {
	install,
};
